// extracted by mini-css-extract-plugin
export default {"link":"logo_link__rS-WS","imageText":"logo_imageText__p-yum","button":"logo_button__8uw1+"};